import { CART_RECOVERY_SOURCE_ENABLED, recoveryEligibilityState } from "./cartRecovery";
import { cancelCartRecoveryCheckout } from "./cartRecovery.functions";
import { acknowledgeCheckoutIdentity, type captureCheckoutIdentity } from "./cartCheckoutIdentity";

/** Source OFF bypasses recovery entirely. Server distinguishes proven non-enrollment from unknown.
 * An unknown response with unavailable gates permits checkout WITHOUT claiming recovery coverage;
 * activation remains blocked until these uncertainty paths are independently verified. */
export async function cancelRecoveryBeforeCheckout(cartId: string | null,
  identity: ReturnType<typeof captureCheckoutIdentity>): Promise<boolean> {
  let ticket: ReturnType<typeof recoveryEligibilityState.invalidate> = null;
  return acknowledgeCheckoutIdentity(identity, CART_RECOVERY_SOURCE_ENABLED, cartId,
    (owner) => { ticket = recoveryEligibilityState.invalidate(owner); },
    async (input) => {
      const result = await cancelCartRecoveryCheckout({ data: input });
      if (identity.matches() && result.ownerId === identity.userId &&
        result.checkoutAllowed && result.recoveryCovered &&
        (result.state === "acknowledged" || result.state === "not_enrolled"))
        recoveryEligibilityState.afterAcknowledgment(ticket);
      return result;
    });
}